import React, {Component} from 'react';
// helpers
import { getCricketMarketNameByCode } from '../../../helpers/marketHelpers';
import {getText} from '../../../../../helpers/localization';
// components
import LockedBet from '../../../components/lockedBet';
import {PLACED, VOIDED} from "../../../../../constants/identifiers";
import style from "../../../css/lockedBetCricket.css";
import {getGameTitle} from "../../../../../helpers/eventHelpers";


class LockedBetCricket extends Component {

    _createEventDetails(eventDetails) {
        let teamScore = eventDetails.fullTimeResult.split(";")[0];
        let runsOffFirstDelivery = eventDetails.fullTimeResult.split(";")[2];
        let firstMethodOfDismissal = eventDetails.fullTimeResult.split(";")[3];
        let firstTeamScore = eventDetails.team1;
        
        let firstTeamRunsUI = '';
        if (eventDetails.firstTeamToScore !== '') {
            firstTeamRunsUI = (<div className={`${style.eventDetailsLine}`}>
                <div className={style.eventDetailsLineLeft}>{getText('FIRST_TEAM_RUNS_OFF_FIRST_BALL', this.props.store,[firstTeamScore],)}</div>
                <div
                    className={style.eventDetailsLineRight}>{runsOffFirstDelivery}</div>
            </div>);
        }
        let firstDismissalUI = '';
        if (eventDetails.lastTeamToScore !== '') {
            firstDismissalUI = (<div className={`${style.eventDetailsLine} ${style.even}`}>
                <div className={style.eventDetailsLineLeft}>{getText('FIRST_TEAM_WICKET_LOST_DISMISSAL_TYPE', this.props.store,[firstTeamScore],)}</div>
                <div
                    className={style.eventDetailsLineRight}>{getText(firstMethodOfDismissal,this.props.store)}</div>
            </div>);
        }

        return (
            <div>
                <div className={`${style.eventDetailsLine} ${style.even}`}>
                    <div className={style.eventDetailsLineLeft}>{getText('FINAL_SCORE', this.props.store)}</div>
                    <div className={style.eventDetailsLineRight}>{teamScore}</div>
                </div>
            {firstTeamRunsUI}
            {firstDismissalUI}
            </div>
        );
    }

    render() {

        let eventDetails;
        let bet = this.props.betSelection.Bets[0];
        let teamOne = bet.EventDetails.team1;
        let teamTwo = bet.EventDetails.team2;
        let homeTeam = getText(teamOne, this.props.store);
        let awayTeam = getText(teamTwo, this.props.store);

        let voidStatus = bet.State === 'VOIDED';
        let title = `${homeTeam} ${getText('VS', this.props.store)} ${awayTeam}`;
        let eventName = getGameTitle(title, bet.EventTime, this.props.store.getState().vpp.systemLanguage);
        let marketInfo = bet.OpaqueData === undefined ? null : JSON.parse(bet.OpaqueData);
        let betType = getText(getCricketMarketNameByCode(bet.Market.Code), this.props.store, [homeTeam, awayTeam]);
        let odd = bet.Market.Price;
        let name = '';
        if (marketInfo !== null) {
            name = isNaN(marketInfo.cricketSelection)
                ? (marketInfo.cricketSelection.includes("Under") || marketInfo.cricketSelection.includes("Over"))
                ? getText((marketInfo.cricketSelection.split(" "))[0],this.props.store,[(marketInfo.cricketSelection.split(" "))[1]])
                :getText(marketInfo.cricketSelection, this.props.store, [homeTeam, awayTeam])
                : marketInfo.cricketSelection;
        }

        if (this.props.betsType !== PLACED && this.props.betsType !== VOIDED && !voidStatus) {
            eventDetails = (
                <div className={style.eventDetailsWrapper}>
                    <div className={style.eventDetails}>
                        {this._createEventDetails(bet.EventDetails)}</div>

                </div>
            );
            eventName.score = eventName.gameTitle;
            eventName.formated = (<div className={style.cricketTitle}>
                <div className={style.eventTime}>{`${eventName.dayMonthYear} `}{`${eventName.hoursMinutes} `}</div>
                <p className={style.resultContainer}>
                    {`${homeTeam} `}{` ${bet.EventDetails.fullTimeResult.split('').join(' ')} `}{` ${awayTeam}`}</p>

                {/*<div className={style.teamName}>{bet.EventDetails.team1}</div>*/}
                {/*<div className={style.result}>{bet.EventDetails.fullTimeResult.split('').join(' ')}</div>*/}
                {/*<div className={style.teamName}>{bet.EventDetails.team2}</div>*/}
            </div>);
        }

        return (<LockedBet store={this.props.store} index={this.props.index} betSelection={this.props.betSelection}
                           betType={betType} odd={odd} eventName={eventName} names={[name]}
                           isSettledBet={this.props.isSettledBet} eventDetails={eventDetails}
                           voidStatus={voidStatus}/>);
    }
}

export default LockedBetCricket;



// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/modules/cricket/components/lockedBetCricket.js